import React from 'react';
import styled from 'styled-components';

const ContainerStatusPublicador = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
`;

const IconeStatusPublicador = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
`;

const IconeConfirmadoPublicador = styled.svg`
    width: 16px;
    height: 16px;
`;

const IconePendentePublicador = styled.svg`
    width: 16px;
    height: 16px;
    stroke: #9D9D09;
    stroke-width: 1.5;
`;

const IconeCanceladoPublicador = styled.svg`
    width: 16px;
    height: 16px;
    stroke: #A72424;
    stroke-width: 1.5;
`;

const IconeCanceladoCoordenadorPublicador = styled.svg`
    width: 16px;
    height: 16px;
    stroke: #8B0000;
    stroke-width: 1.5;
`;

const NomePublicador = styled.span`
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    color: #333;
`;

const StatusPublicador = ({ publicador }) => {
    const renderIconeStatus = (status) => {
        switch (status) {
            case 'Confirmado':
                return (
                    <IconeConfirmadoPublicador xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                        <path d="M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#24A788" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.66699 12.633L10.172 14.354C10.271 14.4673 10.3944 14.5568 10.5328 14.6159C10.6713 14.6749 10.8213 14.7019 10.9716 14.6949C11.1219 14.6879 11.2688 14.647 11.4011 14.5753C11.5335 14.5037 11.6479 14.4031 11.736 14.281L15.333 9.29999" stroke="#24A788" strokeLinecap="round" strokeLinejoin="round" />
                    </IconeConfirmadoPublicador>
                );
            case 'Cancelado':
                return (
                    <IconeCanceladoPublicador xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                        <path d="M15 9L9 15M9 9L15 15M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#A72424" strokeLinecap="round" strokeLinejoin="round" />
                    </IconeCanceladoPublicador>
                );
            case 'Cancelado_Coordenador':
                return (
                    <IconeCanceladoCoordenadorPublicador xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                        <path d="M15 9L9 15M9 9L15 15M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#8B0000" strokeLinecap="round" strokeLinejoin="round" />
                    </IconeCanceladoCoordenadorPublicador>
                );
            case 'Pendente':
            default:
                return (
                    <IconePendentePublicador xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                        <path d="M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#9D9D09" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 16V11H11.5M11.5 16H12.5M12 8.5V8" stroke="#9D9D09" strokeLinecap="round" strokeLinejoin="round" />
                    </IconePendentePublicador>
                );
        }
    };

    return (
        <ContainerStatusPublicador>
            <IconeStatusPublicador>
                {renderIconeStatus(publicador?.statusIndividual || 'Pendente')}
            </IconeStatusPublicador>
            <NomePublicador>{publicador?.nome}</NomePublicador>
        </ContainerStatusPublicador>
    );
};

export default StatusPublicador;